module.exports = __webpack_public_path__ + "img/heatloss-example.b244ebc6.jpg";